import { Component, Input } from '@angular/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';
@Component({
  selector: 'fgb-account-layout',
  templateUrl: './account-layout.component.html',
})
export class AccountLayoutComponent {
  @Input() memberName: string = '';
  @Input() pageTitle: string;
  @Input() backButtonLink?: string;

  
  constructor(
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.navigationService.hideMobileNav();
  }
  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
